module.exports = __webpack_public_path__ + "static/media/image_not_there.6edd9bb4.jpg";